import { render, staticRenderFns } from "./DetalleTimbres.vue?vue&type=template&id=32f0fdd6&scoped=true"
import script from "./DetalleTimbres.vue?vue&type=script&lang=js"
export * from "./DetalleTimbres.vue?vue&type=script&lang=js"
import style0 from "./DetalleTimbres.vue?vue&type=style&index=0&id=32f0fdd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0fdd6",
  null
  
)

export default component.exports